import vxSpinner from '../../common/vx-spinner/vx-spinner.vue';
import globals from '../../common/globals';
import CheckOutService from '../../common/services/checkout-service';
import checkoutTrackingMixin from '../../common/mixins/checkout-tracking-mixin';

import {
  country,
} from '../../common/mixins/vx-enums';

export default {
  name: 'vx-review-lease-agreement',
  mixins: [checkoutTrackingMixin],
  components: {
    vxSpinner,
  },
  props: {
    // Text coming from property file
    i18n: Object,
    // List of countries
    country: Object,
    // Indicates if Lease is Accepted
    leaseAccepted: Boolean,
    // Indicates if page is order details
    orderDetails: Boolean,
  },
  data() {
    return {
      language: 'en',
      globals,
      checkOutService: new CheckOutService(),
      isActive: true,
      leaseAgrementData: {},
      countryEnum: country,
      legalAgreementName: '',
      legalAgreementContent: '',
      leaseAcceptedBtn: false,
    };
  },

  computed: {},
  mounted() {
    this.getLeaseAgrement();
  },
  methods: {
    /**
     * This function stores the lease agreement decision taken by the user
     * @param  {Boolean} agreementDecision lease agreement decision
     */
    agreementDecision(agreementDecision, event) {
      const agreementDetails = {
        agreementDecision,
        id: this.leaseAgrementData.legalTermsId,
      };
      this.$emit('onAcceptingTerms', agreementDetails);
      const decision = agreementDecision ? 'Accept' : 'Decline';
      if (globals.isB2B()) {
        this.sendEventToDataLayer('checkout_option', 3, decision);
      }
    },
    /**
     * This function gets the lease agreement details in language chosen
     */
    getLeaseAgrement() {
      this.language = this.language.toLowerCase();
      const setLanguage = `${this.country.isocode}_${this.language}`;
      this.checkOutService.leaseAgreement({}, this.handleLeaseAgrementLanguageResponse, this.handleLeaseAgrementLanguageError, setLanguage);
      this.$refs.spinner.showSpinner();
    },
    /**
     * This function handles the error lease agreement details
     */
    handleLeaseAgrementLanguageError(error) {
      this.$refs.spinner.hideSpinner();
    },
    /**
     * This function handles the success lease agreement details
     */
    handleLeaseAgrementLanguageResponse(response) {
      this.$refs.spinner.hideSpinner();
      if (response) {
        this.$nextTick(() => {
          this.leaseAgrementData = response.data;
          this.legalAgreementName = response.data.legalTermName;
          this.legalAgreementContent = response.data.legalTermsText;
        });
      }
    },
    /**
     * This function toggles the language the user wants to view the lease agreement in
     */
    toggleLanguage(event) {
      // Check value
      if (this.isActive) {
        this.isActive = false;
      } else {
        this.isActive = true;
      }
      this.language = event.target.textContent;
      this.getLeaseAgrement();
    },
    /**
     * This function emits when user accepts lease agreement
     */
    agreementAccepted(event) {
      this.$emit('acceptedTerms');
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/checkout/vx-review-lease-agreement/vx-review-lease-agreement.js